import React from 'react';

/**
 * Fixed top progress bar showing reading progress through the current page.
 * Sits above everything (z-50) so it's always visible.
 */
const ReadingProgressBar = ({ progress, isDark }) => {
  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 h-1 pointer-events-none"
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={`Reading progress: ${progress}%`}
    >
      {/* Track */}
      <div className={`w-full h-full ${ isDark ? 'bg-gray-800' : 'bg-gray-200/60' }`} />
      {/* Fill */}
      <div
        className="absolute top-0 left-0 h-full bg-gradient-to-r from-primary via-secondary to-accent transition-all duration-150 ease-out"
        style={{ width: `${progress}%` }}
      />
      {/* Percentage badge — appears at the right edge of the fill */}
      {progress > 5 && (
        <div
          className={`absolute top-1 text-[10px] font-bold px-1.5 py-0.5 rounded-sm shadow-sm pointer-events-none select-none transition-all duration-150 ${
            isDark ? 'bg-gray-900 text-primary' : 'bg-white text-primary'
          }`}
          style={{ left: `calc(${progress}% - 28px)` }}
        >
          {progress}%
        </div>
      )}
    </div>
  );
};

export default ReadingProgressBar;
